<template>
  <div class="add-step">
    <ins-header
      :title="headerTitle"
      :hasVerifi="false"
      @back="goBack"
    ></ins-header>
    <div class="add-card">
      <div v-if="(ticketList = [])" class="no-ticket">
        <img
          src="@/assets/img/support_ticket.svg"
          style="filter: opacity(0.5) drop-shadow(0px 0px 0px #8c92ac)"
        />
        <h4 style="margin-top: 38px">هنوز هیچ تیکتی ارسال نشده</h4>
      </div>
      <table v-else class="setting-table">
        <tr v-for="ticket in ticketList" :key="ticket.id">
          <td>
            <!-- <input
              type="checkbox"
              id="switchNotification"
              @change="chenge"
            /><label for="switchNotification"></label> -->
          </td>
          <td>
            {{ ticket }}
          </td>
          <td>
            <img src="@/assets/icons/notification.svg" />
          </td>
        </tr>
      </table>
      <button class="m-btn f-bootom" @click="sendTicketRouteHandler">
        ایجاد تیکت جدید
      </button>
    </div>
  </div>
</template>

<script>
import InsHeader from "../../../layouts/inside-header.vue";
export default {
  components: {
    InsHeader,
  },
  computed: {
    headerTitle() {
      return this.$route.meta.prtitle;
    },
  },
  data() {
    return {
      ticketList: [],
    };
  },
  methods: {
    sendTicketRouteHandler() {
      this.$router.push({ name: "SendTicket" });
    },

    goBack() {
      this.$router.back();
    },
  },
};
</script>

<style scoped>
.f-bootom {
  position: fixed;
  bottom: 22px;
  right: 6px;
  width: 95%;
}
</style>
